module.exports = __webpack_public_path__ + "img/27_46.959ddbc1.png";